// User Settings UI
import { getUserLanguage, getUserById, updateUserProfile, uploadProfilePicture } from '../db.js';
import { getCurrentUser, signOut } from '../auth.js';

export async function showUserSettings() {
    const user = getCurrentUser();
    if (!user) return;

    let profile = { displayName: '', photoURL: '', language: 'fr' };
    try {
        profile = await getUserById(user.uid);
    } catch (e) {
        profile = {
            displayName: user.displayName || '',
            photoURL: user.photoURL || '',
            language: localStorage.getItem('user_preferred_lang') || 'fr'
        };
    }

    // Create modal
    let modal = document.getElementById('user-settings-modal');
    if (modal) modal.remove();

    const html = `
    <div id="user-settings-modal" class="modal">
        <div class="modal-content" style="max-width:500px;">
            <div class="modal-header">
                <h3>👤 Paramètres du profil</h3>
                <button class="close-btn">&times;</button>
            </div>
            <div class="modal-body">
                <form id="user-settings-form">
                    <div class="form-group" style="display: flex; flex-direction: column; align-items: center; gap: 10px; margin-bottom: 24px;">
                        <div class="avatar-preview-container" style="position: relative; width: 100px; height: 100px;">
                            <img id="avatar-preview" src="${profile.photoURL || 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y'}" 
                                 style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover; border: 2px solid var(--primary);">
                            <label for="settings-photo-upload" style="position: absolute; bottom: 0; right: 0; background: var(--primary); color: white; width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; border: 2px solid var(--surface); box-shadow: 0 2px 4px rgba(0,0,0,0.2);">
                                📷
                            </label>
                        </div>
                        <input type="file" id="settings-photo-upload" accept="image/*" style="display: none;">
                        <small style="color: var(--text-muted); font-size: 0.85rem;">Cliquez pour changer votre photo de profil</small>
                    </div>

                    <div class="form-group">
                        <label for="settings-name">Nom d'affichage</label>
                        <input type="text" id="settings-name" class="form-control" value="${profile.displayName || ''}" placeholder="Votre nom sur les publications">
                    </div>

                    <div class="form-group">
                        <label for="preferred-language">Langue préférée Bible</label>
                        <select id="preferred-language" class="form-control">
                            <option value="malagasy" ${profile.language === 'malagasy' ? 'selected' : ''}>Malagasy</option>
                            <option value="french" ${profile.language === 'french' ? 'selected' : ''}>Français</option>
                            <option value="english" ${profile.language === 'english' ? 'selected' : ''}>English</option>
                            <option value="spanish" ${profile.language === 'spanish' ? 'selected' : ''}>Español</option>
                        </select>
                    </div>

                    <div style="margin-top:24px; padding-top:18px; border-top: 1px solid var(--border); display:flex; flex-direction: column; gap: 12px;">
                        <button type="submit" class="btn btn-primary btn-block">Enregistrer les modifications</button>
                        <button type="button" class="btn btn-secondary btn-block" id="logout-settings-btn" style="color: #ff4d4d; border-color: rgba(255, 77, 77, 0.3);">
                            🚪 Se déconnecter
                        </button>
                        <button type="button" class="btn btn-secondary btn-block" id="cancel-settings">Annuler</button>
                    </div>
                </form>
            </div>
        </div>
    </div>`;

    document.body.insertAdjacentHTML('beforeend', html);
    modal = document.getElementById('user-settings-modal');
    modal.style.display = 'flex';

    // Events
    modal.querySelector('.close-btn').addEventListener('click', () => modal.remove());
    modal.querySelector('#cancel-settings').addEventListener('click', () => modal.remove());

    // Logout from within settings
    modal.querySelector('#logout-settings-btn').addEventListener('click', async () => {
        if (confirm('Voulez-vous vraiment vous déconnecter ?')) {
            modal.remove();
            await signOut();
        }
    });

    // Photo upload preview
    const photoUpload = modal.querySelector('#settings-photo-upload');
    const avatarPreview = modal.querySelector('#avatar-preview');
    let selectedFile = null;

    photoUpload.addEventListener('change', (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check file size (max 2MB)
            if (file.size > 2 * 1024 * 1024) {
                alert('La photo est trop lourde (max 2 Mo)');
                photoUpload.value = '';
                return;
            }
            selectedFile = file;
            const reader = new FileReader();
            reader.onload = (e) => {
                avatarPreview.src = e.target.result;
            };
            reader.readAsDataURL(file);
        }
    });

    const form = modal.querySelector('#user-settings-form');
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const submitBtn = form.querySelector('button[type="submit"]');
        submitBtn.disabled = true;
        submitBtn.textContent = '⏳ Enregistrement...';

        const name = modal.querySelector('#settings-name').value;
        const lang = modal.querySelector('#preferred-language').value;
        let photoURL = profile.photoURL;

        try {
            // Upload photo if a new one was selected
            if (selectedFile) {
                submitBtn.textContent = '📤 Upload de la photo...';
                photoURL = await uploadProfilePicture(user.uid, selectedFile);
            }

            await updateUserProfile(user.uid, {
                displayName: name,
                photoURL: photoURL,
                language: lang
            });

            // Sync with local storage for language
            localStorage.setItem('user_preferred_lang', lang);

            alert('Profil mis à jour avec succès !');
            modal.remove();

            // Reload to show changes (especially name in header/feed)
            window.location.reload();
        } catch (err) {
            console.error(err);
            alert('Erreur lors de la sauvegarde : ' + err.message);
            submitBtn.disabled = false;
            submitBtn.textContent = 'Enregistrer les modifications';
        }
    });
}

export default showUserSettings;
